import MBRModal from './MBRModal';

export default MBRModal;



// WEBPACK FOOTER //
// ./app/javascript/common/components/MBRModal/index.js